export enum PointStatusEnum {
  online = 'online',
  offline = 'offline',
  test = 'test'
}

export enum PointFilterEnum {
  name = 'name',
  status = 'status'
}

export enum PointDetailsQueryEnum {
  point_id = 'point_id'
}

export enum PointDetailsShowInfoStatusEnum {
  yes = '1',
  no = '0'
}

export enum PointFeesDetailsAccrualTypeEnum {
  internal = 'internal',
  external = 'external'
}
